import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <>
      <Helmet>
        <title>Oops! Something Went Wrong</title>
        <meta
          name="description"
          content="An error occurred while processing your request. Please try again later or contact support if the issue persists."
        />
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
          rel="stylesheet"
        />
        <style>{`
          .error-page {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
            position: relative;
            overflow: hidden;
            padding: 2rem 0;
          }
          
          .error-shape {
            position: absolute;
            opacity: 0.1;
            z-index: 0;
          }
          
          .error-shape-1 {
            top: 10%;
            left: 5%;
            width: 150px;
            height: 150px;
            background: #6c63ff;
            border-radius: 50%;
          }
          
          .error-shape-2 {
            bottom: 10%;
            right: 5%;
            width: 200px;
            height: 200px;
            background: #ff6584;
            border-radius: 50%;
          }
          
          .error-content {
            position: relative;
            z-index: 1;
            text-align: center;
            padding: 3rem;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 1rem;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
            max-width: 600px;
            margin: 0 auto;
          }
          
          .error-code {
            font-size: 8rem;
            font-weight: 800;
            color: #6c63ff;
            line-height: 1;
            margin-bottom: 1rem;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
          }
          
          .error-title {
            font-size: 2rem;
            font-weight: 700;
            color: #333;
            margin-bottom: 1rem;
          }
          
          .error-message {
            font-size: 1.1rem;
            color: #666;
            margin-bottom: 2rem;
          }
          
          .error-btn {
            display: inline-block;
            padding: 0.75rem 2rem;
            background: #6c63ff;
            color: white;
            border-radius: 50px;
            text-decoration: none;
            font-weight: 600;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(108, 99, 255, 0.3);
          }
          
          .error-btn:hover {
            background: #5a52d5;
            transform: translateY(-3px);
            box-shadow: 0 7px 20px rgba(108, 99, 255, 0.4);
            color: white;
          }
          
          .error-btn-icon {
            margin-left: 0.5rem;
          }
          
          @media (max-width: 768px) {
            .error-code {
              font-size: 6rem;
            }
            
            .error-title {
              font-size: 1.5rem;
            }
            
            .error-message {
              font-size: 1rem;
            }
            
            .error-shape-1 {
              width: 100px;
              height: 100px;
            }
            
            .error-shape-2 {
              width: 150px;
              height: 150px;
            }
          }
        `}</style>
      </Helmet>
      
      <section className="error-page">
        <div className="error-shape error-shape-1"></div>
        <div className="error-shape error-shape-2"></div>
        
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="error-content">
                <div className="error-code">404</div>
                <h2 className="error-title">Oops! Page Not Found</h2>
                <p className="error-message">
                  The page you are looking for doesn't exist or has been moved. 
                  Let's get you back on track!
                </p>
                <Link to="/" className="error-btn">
                  Back to Home
                  <span className="error-btn-icon">→</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ErrorPage;